/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import Space from 'material/space/space';
import {  } from '@insticator/insticator-ui/dist/material';

import { ReactComponent as ButtonClickIcon } from 'assets/icons/product-layout/preview/button-click.svg'
import { ReactComponent as CustomIcon } from 'assets/icons/product-layout/preview/custom.svg'

// styles
import injectSheet from 'react-jss'
import styles from './overlay_styles'
import Commenting from '../products/commenting/commenting';
import ProductTabs from '../producttabs/producttabs';
import ControlBar from '../controlbar/controlbar';
import TrendingNow from '../products/trendingnow/trendingnow';
import ArticleSentiment from '../products/articlesentiment/articlesentiment';


/* ========== ~~~~~~~~~~ PRODUCT MANAGER: PAGE SETUP : PREVIEW ~~~~~~~~~~ ========== */
const Overlay = injectSheet(styles)((props) => {
  const { controlBarPlacement, controlBarAlignment, trigger, products = [], showCommenting, showTrendingNow, showArticleSentiment } = props
  const [selectedProduct, selectProduct] = useState(products.length ? products[0] : 'COMMENTING_V2')
  const flexDirection = trigger !== 'CONTROL_BAR' ? 'column' : controlBarPlacement === 'LEFT_EDGE' ? 'row' : controlBarPlacement === 'RIGHT_EDGE' ? 'row-reverse' : 'column-reverse'
  
  const noProducts = !showCommenting && !showTrendingNow && !showArticleSentiment
  if(noProducts) return null

  return (
    <Space klass={`overlay ${props.classes.overlay} ${trigger}`} direction={flexDirection}>
      <Space klass={`trigger ${trigger} ${controlBarAlignment}_ALIGNMENT ${controlBarPlacement}_PLACEMENT`} alignItems={trigger !== 'CONTROL_BAR' ? 'center' : 'flex-start'} justifyContent={trigger !== 'CONTROL_BAR' ? 'center' : 'flex-end'}>
        {trigger === 'BUTTON' && (
          <div>
            <div className={'button'}>BUTTON</div>
            <ButtonClickIcon className='buttonclickicon' />
          </div>
        )}
        {trigger === 'CUSTOM' && (
          <div>
            <CustomIcon width={80} height={80} />
          </div>
        )}
        {trigger === 'CONTROL_BAR' && (
           <div>
            <ControlBar 
              alignment={controlBarAlignment} 
              placement={controlBarPlacement}
              products={products} 
              showCommenting={showCommenting}  
              showTrendingNow={showTrendingNow}
              showArticleSentiment={showArticleSentiment}
              onSelect={product => selectProduct(product)}  
            />
          </div>
        )}
      </Space>
      <Space klass={'overlaycontainer'} direction={'column'}>
        <ProductTabs 
          products={products} 
          showCommenting={showCommenting} 
          showTrendingNow={showTrendingNow}
          showArticleSentiment={showArticleSentiment}
          onSelect={product => selectProduct(product)} 
        />
        <Space klass={'selectedproduct'}>
          {selectedProduct === 'COMMENTING_V2' && showCommenting && <Commenting />}
          {selectedProduct === 'TRENDING_NOW_V2' &&  showTrendingNow && <TrendingNow />}
          {selectedProduct === 'ARTICLE_SENTIMENT_V2' && showArticleSentiment && <ArticleSentiment />}
        </Space>
      </Space>
    </Space>
   
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Overlay;